import classes from "./Cart.module.css";
import Modal from "../UI/Modal";
import { useContext } from "react";
import CartContext from "../../Store/CartContext";
import CartItem from "./CartItem";

const Cart = (props) => {
  const useCrt = useContext(CartContext);
  const totalAmount = `${useCrt.totalAmount.toFixed(2)} lei`;
  const existItems = useCrt.items.length > 0;
  const cartItemRemoveHandler = (id) => {};

  const cartItemAddHandler = (id) => {};

  const cartItems = (
    <ul className={classes["cart-items"]}>
      {useCrt.items.map((item) => (
        <CartItem
          key={item.id}
          name={item.name}
          amount={item.amount}
          price={item.price}
          onRemove={cartItemRemoveHandler.bind(null, item.id)}
          onAdd={cartItemAddHandler.bind(null, item.id)}
        />
      ))}
    </ul>
  );

  return (
    <Modal onClose={props.onClose}>
      {cartItems}
      <div className={classes.total}>
        <span>Total Amount</span>
        <span>{totalAmount}</span>
      </div>
      <div className={classes.actions}>
        <button className={classes["button--alt"]} onClick={props.onClose}>
          Close
        </button>
        {existItems && <button className={classes.button}>Order</button>}
      </div>
    </Modal>
  );
};

export default Cart;
